<template>
  <div v-if="show" class="flex">
    <span class="flex items-center h-[30px] px-2 text-sm font-medium text-[#E2E5ED] border border-[#E2E5ED] bg-[#1A56DB] rounded-md">
      <OIcon icon="raise" svg-class="mr-2" />
      {{ $t('main.category-live-count', { count: count }) }}
    </span>
  </div>
</template>

<script>
import { defineComponent, inject, ref, useRoute, computed, watch } from '@nuxtjs/composition-api';
import { useCategory } from '~/modules/category/state/useCategoryState';
import { OIcon } from '~/modules/common/components/ui';

export default defineComponent({
  components: {
    OIcon,
  },
  setup() {
    const route = useRoute();
    const { liveCounts } = useCategory();
    const article = inject('article', null);
    const count = ref(0);

    watch(liveCounts, () => {
      count.value = liveCounts.value[article.legacyId];
    });

    const routeName = route.value.name?.split('___')[0]; // i18n prefix remove
    const show = computed(() => count.value > 0 && routeName?.startsWith('/test'));
    return { count, show };
  },
});
</script>
